import { FC } from 'react';
import { AllieSelectProps } from '../../../../../components';
import { DataContentBaseProps } from './DataContent.types';
import { AllieControlledSelect } from '../../../ControlledSelect';

interface ContentSelectProps extends AllieSelectProps {}

export const ContentSelect: FC<DataContentBaseProps<ContentSelectProps>> = ({
  data: { options, selected, onChange },
}) => (
  <AllieControlledSelect
    options={options}
    onSelect={onChange}
    initialValue={selected!.toString()}
  />
);
